import { Component, OnInit, AfterViewInit } from '@angular/core';
import {
  faArrowRight,
  faArrowLeft,
  faChevronRight,
  faChevronLeft,
  faMapMarkerAlt,
  faPhoneAlt,
  faPaperPlane
} from '@fortawesome/free-solid-svg-icons';
import { gsap } from 'gsap';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// import anime.js
import anime from 'animejs/lib/anime.es.js';

// import Swiper bundle with all modules installed
import swiper from 'swiper/bundle';

import {magicMouse} from '../../../assets/js/magic_mouse.js';


declare var $;


@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit, AfterViewInit {

  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faArrowLeft = faArrowLeft;
  faArrowRight = faArrowRight;
  faMapMarkerAlt = faMapMarkerAlt;
  faPhoneAlt = faPhoneAlt;
  faPaperPlane = faPaperPlane;

  userName = '';
  userEmail = '';
  userPhone = '';
  userMessage = '';


  contactFormHeader: string = `Let's Talk`;


  constructor() { }

  ngOnInit(): void {
    // Animations
    // Register plugins to be used and avoid bundler tree shaking losses
    gsap.registerPlugin(
      ScrollTrigger,
      ScrollToPlugin,
      CSSRulePlugin,
    );
    // initialize magic mouse plugin
    const magicmouseoptions = {
      cursorOuter: 'circle-basic',
      hoverEffect: 'circle-move',
      hoverItemMove: true,
      defaultCursor: true,
      outerWidth: 40,
      outerHeight: 40
    };
    magicMouse(magicmouseoptions);

    globalThis.scrollTo(0, 0);

    const opSystem = this.getMobileOperatingSystem();
    console.log(opSystem);

    if ( this.getMobileOperatingSystem() === 'iOS' ) {
      $('.map-container iframe').hide();
      $('.map-container iframe').hide();
      console.log('iOS');
    }else{
      $('.map-container iframe').show();
      console.log('NOT iOS');
    }

    $('#magicMouseCursor').addClass('is-loading');
    const welcomeTL = gsap.timeline();
    welcomeTL
    .to( '.loading-container' , {z: 0.1, rotationZ: 0.01, force3D: true,
      autoAlpha: 1,
      duration: 1,
      ease: 'Power1.easeOut',
    })
    .to( '.loading-container' , {z: 0.1, rotationZ: 0.01, force3D: true,
      autoAlpha: 0,
      duration: 2,
      ease: 'Power1.easeOut',
    })
    .from( 'main' , {z: 0.1, rotationZ: 0.01, force3D: true,
      autoAlpha: 0,
      duration: 1,
      ease: 'Power3.easeOut',
    }, '-=2')
    .to( '.loading-container' , {z: 0.1, rotationZ: 0.01, force3D: true,
      y: '-100%',
      autoAlpha: 0,
      duration: 0.1,
      ease: 'Power2.easeOut',
    })

    .from( '.header-wrapper' , {z: 0.1, rotationZ: 0.01, force3D: true,
        y: -100,
        autoAlpha: 0,
        duration: 2,
        ease: 'Power3.easeOut',
    }, '-=2')
    .from( '.map-container' , {z: 0.1, rotationZ: 0.01, force3D: true,
        y: -100,
        autoAlpha: 0,
        duration: 1.2,
        ease: 'Power3.easeOut',
    }, '-=1.55')
    .from( '.contact-form-wrapper' , {z: 0.1, rotationZ: 0.01, force3D: true,
        y: -50,
        autoAlpha: 0,
        ease: 'Power3.easeOut',
        duration: 1.2,
    });


    setTimeout(() => {
      $('#magicMouseCursor').removeClass('is-loading');
    }, 3000);

  }


  ngAfterViewInit(): void {

    setTimeout( () => {


      // const headerTL = gsap.timeline();
      // headerTL.from( '.header-wrapper' , {z: 0.1, rotationZ: 0.01, force3D: true,
      //   y: -100,
      //   autoAlpha: 0,
      //   duration: 2,
      //   ease: 'Power3.easeOut',
      // })
      // .from( '.map-container' , {z: 0.1, rotationZ: 0.01, force3D: true,
      //   y: -100,
      //   autoAlpha: 0,
      //   duration: 1.2,
      //   ease: 'Power3.easeOut',
      // }, '-=1.55')
      // .from( '.contact-form-wrapper' , {z: 0.1, rotationZ: 0.01, force3D: true,
      //   y: -50,
      //   autoAlpha: 0,
      //   ease: 'Power3.easeOut',
      //   duration: 1.2,
      // });


      //// on scroll
      // gsap.from( '.contact-form-wrapper' , {z: 0.1, rotationZ: 0.01, force3D: true,
      //   y: -50,
      //   autoAlpha: 0,
      //   ease: 'power1.out',
      //   scrollTrigger: {
      //     trigger: '.contact-form-wrapper',
      //     scrub: 2,
      //     start: 'top bottom',
      //     end: 'bottom bottom'
      //   }
      // });
      gsap.from( '.contact-info .info-container' , {z: 0.1, rotationZ: 0.01, force3D: true,
        y: -100,
        autoAlpha: 0,
        stagger: 0.1,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: '.contact-info',
          scrub: 2,
          start: 'top bottom',
          end: 'bottom bottom'
        }
      });

      gsap.from( '.next-container' , {z: 0.1, rotationZ: 0.01, force3D: true,
        y: -100,
        autoAlpha: 0,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: '.next-container',
          scrub: 3,
          start: 'top bottom',
          end: 'bottom bottom'
        }
      });
    }, 0);
  }

  getMobileOperatingSystem(): string {
    const userAgent = navigator.userAgent || navigator.vendor || globalThis.opera;

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
        return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
    }

    return 'unknown';
  }

}
